// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__MWO_-","rootSmall":"AddTileButton_rootSmall__1iLg-"};